export default "__VITE_ASSET__693da51e__"